var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopLeftDecoration = function SvgTopLeftDecoration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 56,
    viewBox: "0 0 42 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    transform: "rotate(-11 78.427 2.537)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.087,
    height: 21.864,
    x: 39.063,
    y: 0.369,
    rx: 3.043,
    transform: "rotate(-10 42.106 11.301)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.087,
    height: 27.682,
    x: 14.753,
    y: 0.789,
    rx: 3.043,
    transform: "rotate(-43 17.797 14.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.087,
    height: 24.199,
    x: 10.341,
    y: 28.71,
    rx: 3.043,
    transform: "rotate(-77 13.385 40.81)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 3,
    r: 3,
    fill: "#A358DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 37,
    r: 3,
    fill: "#A358DF"
  }))));
};
export default SvgTopLeftDecoration;